// extracted by mini-css-extract-plugin
module.exports = {"withBorder":"CardsContainer_withBorder__J1elM"};